import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: '/services/plugin-live-multi-company/v1/company',
    headers: {
        'Access-Control-Allow-Origin': '*'
    }
})

const listCompaniesApi = () => {
    return axiosInstance.get('')
}

const createCompany = company => {
    return axiosInstance.post('', company)
}

const updateCompany = company => {
    return axiosInstance.put(`/${company.id}`, company)
}

const deleteCompany = companyID => {
    return axiosInstance.delete(`/${companyID}`)
}

const deletePerspectiveOfCompany = (companyID, perspectiveID) => {
    return axiosInstance.delete(`/${companyID}/perspective/${perspectiveID}`)
}

const deleteUserGroupOfCompany = (companyID, userGroupID) => {
    return axiosInstance.delete(`/${companyID}/user-group/${userGroupID}`)
}

const deleteUserOfCompany = (companyID, userID) => {
    return axiosInstance.delete(`/${companyID}/user/${userID}`)
}

export {
    listCompaniesApi,
    createCompany,
    deleteUserGroupOfCompany,
    deletePerspectiveOfCompany,
    deleteUserOfCompany,
    updateCompany,
    deleteCompany
}
